import React, { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "../../i18n/TranslationProvider";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import Form from "react-bootstrap/Form";

import Sallie from "../UIComponents/Sallie";
import OnboardingStepHeader from "./OnboardingStepHeader";
import SubmitButton from "../UIComponents/SubmitButton";
import NotificationSchema from "./validations/notificationSchema";
import { postTrackingPrefs } from "../../api/TBIRequests";

import { format } from "date-fns";
import TimeInput from "../UIComponents/TimeInput";
import WeekInput from "../UIComponents/WeekInput";
import stringifyDayOfWeek from "../../lib/stringifyDayOfWeek";
import stringifyWeekOfMonth from "../../lib/stringifyWeekOfMonth";
import customizeMessages from "../../lib/customizeMessages";

const NotificationPrefs = ({ user, setOnboardingPercent }) => {
    const [submitting, setSubmitting] = useState(false);
    const [isEmailAlert, setIsEmailAlert] = useState(true);
    const [timezone, setTimezone] = useState("America/New_York");
    const { t } = useTranslation();
    const history = useHistory();

    useEffect(() => {
        setOnboardingPercent(80);
    }, []);

    useEffect(() => {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        setTimezone(tz || "America/New_York");
    }, []);

    const { register, handleSubmit, errors } = useForm({
        defaultValues: {
            hour: "04",
            partOfDay: "PM",
            monday: true,
            tuesday: true,
            wednesday: true,
            thursday: true,
            friday: true,
            saturday: true,
            sunday: true,
            firstWeek: true,
            secondWeek: true,
            thirdWeek: true,
            fourthWeek: true,
            fifthWeek: true,
        },
        resolver: yupResolver(NotificationSchema),
    });

    const disableDayOfWeek = (e) => {
        setIsEmailAlert(e.target.checked);
    };

    const onSubmit = (data) => {
        setSubmitting(true);
        let notificationData = { emailAlert: data.emailAlert };
        let time;
        if (!data.emailAlert) {
            time = null;
        } else {
            time = format(
                new Date(0, 0, 0, data.partOfDay === "AM" ? data.hour : data.hour + 12, 0),
                "HH:mm"
            );
        }
        notificationData.timeAlert = time;
        const dayOfWeek = stringifyDayOfWeek(data);
        const weekOfMonth = stringifyWeekOfMonth(data);
        notificationData.dayOfWeek = dayOfWeek;
        notificationData.weekOfMonth = weekOfMonth;
        notificationData.tz = timezone;

        postTrackingPrefs({ data: notificationData })
            .then(() => history.push("/additionalInfo"))
            .catch(() => history.push("/oops"));
    };

    const getPossibleMessages = () => ({
        mainHeader: {
            Stroke: t("notificationprefs.header"),
            tbiPatient: t("notificationprefs.header"),
            caregiver: t("notificationprefs.header"),
        },
        sallieText: {
            Stroke: t("notificationprefs.sallie"),
            tbiPatient: t("notificationprefs.sallie"),
            caregiver: t("notificationprefs.sallie"),
        },
    });

    const getMessage = customizeMessages({ getPossibleMessages, user });

    return (
        <>
            <OnboardingStepHeader text={getMessage("mainHeader")} />
            <Sallie text={getMessage("sallieText")} />
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Label as="h6" style={{ width: "100%", margin: "10px 0px 20px 0px" }}>
                    {t("notificationprefs.dashboard")}
                </Form.Label>
                <Form.Row>
                    <Form.Group controlId="email">
                        <Form.Check
                            name="emailAlert"
                            ref={register}
                            type="checkbox"
                            label={t("basicinfo.email")}
                            defaultChecked
                            onChange={disableDayOfWeek}
                        />
                    </Form.Group>
                </Form.Row>

                <WeekInput
                    errors={errors}
                    register={register}
                    label={t("notificationprefs.reminder")}
                    disableStatus={!isEmailAlert}
                />

                <TimeInput
                    errors={errors}
                    register={register}
                    label={t("notificationprefs.day_of_week")}
                    disableStatus={!isEmailAlert}
                />

                <SubmitButton disabled={submitting} type="submit">
                    {t("onboarding.saveContinue")} &gt;
                </SubmitButton>
            </Form>
        </>
    );
};

export default NotificationPrefs;